import { Component, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  private translationService = inject(TranslationService);
  private t = computed(() => this.translationService.t().footer);

  currentYear = new Date().getFullYear();
  copyrightText = computed(() => this.t().copyright.replace('{{year}}', this.currentYear.toString()));
}
